import Price from '~/utils/Price';

import ComparativePrice from './ComparativePrice';
import { Error, ErrorCode } from './Error';
import ReferencedProduct from './ReferencedProduct';

export default class FinalCalculation {
	comparativePrice: ComparativePrice | null;

	percentsOfComparativePrice: number;

	maximumPepValue: Price | null;

	maximumWholesalePrice: Price | null;

	referencedProduct: ReferencedProduct | null;

	potentialPriceDropPercents: number | null;

	emptyResultReason: Error[];

	constructor(
		comparativePrice: ComparativePrice | null,
		percentsOfComparativePrice: number,
		maximumPepValue: Price | null,
		maximumWholesalePrice: Price | null,
		referencedProduct: ReferencedProduct | null,
		potentialPriceDropPercents: number,
		emptyResultReason: Error[]
	) {
		this.comparativePrice = comparativePrice;
		this.percentsOfComparativePrice = percentsOfComparativePrice;
		this.maximumPepValue = maximumPepValue;
		this.maximumWholesalePrice = maximumWholesalePrice;
		this.referencedProduct = referencedProduct;
		this.potentialPriceDropPercents = potentialPriceDropPercents;
		this.emptyResultReason = emptyResultReason;
	}

	hasMissingProductSettings(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiredProductSettingsMissing) !== undefined
		);
	}

	requiresMinOneEuropeanProductErrorCode(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMinOneEuropeanProduct) !== undefined;
	}

	findRequiresMaxOneEuropeanProductError(): Error | null {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMaxOneEuropeanProduct) ?? null;
	}

	isMissingReferenceSettings(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresReferenceSettings) !== undefined;
	}

	isIllegalProductPriceTypeSelected(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.illegalPriceTypeSelected) !== undefined;
	}
}
